import { listOptions } from '@/api/business/bulkTransportOrder'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(listOptions)
